import type { ValueOf } from '@common/utils/utilityTypes';

export const OrganizationTypeWithLinkedProfessions = {
    addictionCareCentre: 'addictionCareCentre',
    centerForMedicalSpecialistCare: 'centerForMedicalSpecialistCare',
    dietitianPractice: 'dietitianPractice',
    ggzInstitution: 'ggzInstitution',
    gpPractice: 'gpPractice',
    hospital: 'hospital',
    independentPractice: 'independentPractice',
    ksyosHospital: 'ksyosHospital',
    medicalDiagnosticCenterLaboratory: 'medicalDiagnosticCenterLaboratory',
    nursingFacility: 'nursingFacility',
    optometryPractice: 'optometryPractice',
    psychiatryCenter: 'psychiatryCenter',
    psychologyPracticePsychotherapyPractice: 'psychologyPracticePsychotherapyPractice',
    skinTherapyPractice: 'skinTherapyPractice',
    testOrganization: 'testOrganization',
} as const;

export type OrganizationTypeWithLinkedProfessions = ValueOf<typeof OrganizationTypeWithLinkedProfessions>;

export const OrganizationType = {
    ...OrganizationTypeWithLinkedProfessions,
    audiologistCenter: 'audiologistCenter',
    dentistPractice: 'dentistPractice',
    gpWeekendCentre: 'gpWeekendCentre',
    hearingAidCenter: 'hearingAidCenter',
    medicalSpecialistCompany: 'medicalSpecialistCompany',
    other: 'other',
    pharmacy: 'pharmacy',
    physicalTherapyPractice: 'physicalTherapyPractice',
    speechTherapyPractice: 'speechTherapyPractice',
} as const;

export type OrganizationType = ValueOf<typeof OrganizationType>;

export const organizationTypesWithRightsToCreateAccountsAndEndEmployments: OrganizationType[] = [
    OrganizationType.gpPractice,
    OrganizationType.testOrganization,
    OrganizationType.centerForMedicalSpecialistCare,
    OrganizationType.medicalDiagnosticCenterLaboratory,
    OrganizationType.psychiatryCenter,
    OrganizationType.psychologyPracticePsychotherapyPractice,
    OrganizationType.nursingFacility,
    OrganizationType.hospital,
];

export const organizationTypesWithCarePathRightsAutoAdder: OrganizationType[] = [
    OrganizationType.gpPractice,
    OrganizationType.testOrganization,
    OrganizationType.optometryPractice,
];
